import AdminRescheduledEventsList from "./rescheduledEvents";

export default AdminRescheduledEventsList;
